import { Icon, Link } from '@nimbus-ds/components';
import { ExclamationCircleIcon } from '@nimbus-ds/icons';
import { DataList, EmptyMessage } from '@nimbus-ds/patterns';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { Card, InterfaceLabel } from '@tiendanube/components';

interface CustomerPriceTablesErrorStateProps {
  headerLabel?: InterfaceLabel | 'skeleton';
  onRetry: () => void;
}

export default function CustomerPriceTablesErrorState({
  headerLabel,
  onRetry,
}: Readonly<CustomerPriceTablesErrorStateProps>) {
  const { t } = useTranslation(Domain.CUSTOMERS);
  const tPath = 'customerDetails.customerPriceTables';

  return (
    <Card title={t(`${tPath}.title`)} headerLabel={headerLabel}>
      <div style={{ marginLeft: '-1rem', marginRight: '-1rem' }}>
        <DataList>
          <DataList.Row id="error-state">
            <EmptyMessage
              icon={
                <Icon
                  color="neutral-textHigh"
                  source={<ExclamationCircleIcon size={32} />}
                />
              }
              title=""
              text={t(`${tPath}.error.title`)}
              actions={
                <Link
                  appearance="primary"
                  textDecoration="none"
                  fontSize="highlight"
                  onClick={onRetry}
                >
                  {t(`${tPath}.error.retry`)}
                </Link>
              }
            />
          </DataList.Row>
        </DataList>
      </div>
    </Card>
  );
}
